import React, { useEffect, useState } from 'react'
import SignIn from '../components/auth/SignIn'
import { validarEntorno } from '../helpers/validarHost';
import './styles/login.scss'

const DEFAULT_LOGO = 'static/media/cosinte-logo.54caa07b.png'
const DEFAULT_SIDE_IMAGE = 'static/media/login-image.25a08348.jpg'

export default function Login({ tenant }) {
  const [logo, setLogo] = useState(DEFAULT_LOGO)
  const [sideImage, setSideImage] = useState(DEFAULT_SIDE_IMAGE)

  useEffect(() => {
    console.log("useEffect")
    const obtenerPersonalizacion = async () => {
      // Construir URL con tenant si existe
      const configUrl = tenant 
        ? `JSON/auth/configuracion.html?tenant=${tenant}`
        : "JSON/auth/configuracion.html";
        
      const request = await validarEntorno(configUrl, "GET")
      if (request.ok) {
        const response = await request.json();
        aplicarEstilos(response?.tema?.colores)
        setLogo(response?.tema?.logo)
        setSideImage(response?.tema?.sideImage)
      }
    }

    const aplicarEstilos = (colores) => {
      document.documentElement.style.setProperty('--color-auth-fondo-formulario', colores?.fondo_formulario);
      document.documentElement.style.setProperty('--color-auth-fondo', colores?.fondo);
      document.documentElement.style.setProperty('--color-auth-boton', colores?.boton);
      document.documentElement.style.setProperty('--color-auth-boton-secundario', colores?.boton_secundario);
      document.documentElement.style.setProperty('--color-auth-campo', colores?.campo);
      document.documentElement.style.setProperty('--color-auth-etiquetas', colores?.etiqueta);
      document.documentElement.style.setProperty('--color-auth-titulo', colores?.titulo);
    }
    obtenerPersonalizacion()
  }
    , [])

  return (
    <div className='mainContainer'>
      <div className='mainCardContainer'>
        <div id='loginContainer'>
          <img
            src={logo}
            alt='logo cosinte'>
          </img>
          <SignIn></SignIn>
        </div>
        <div id='loginImage' style={{ backgroundImage: `url(${sideImage})`}}>
        </div>
      </div>
    </div>
  )
}
